export const getURLByPhase = (call) => {
  const { id } = call;

  return `/narratives/${id}`;
};



// WEBPACK FOOTER //
// ./src/utils/calls.js